import { ExchangeTokenRequest, ExchangeTokenResponse } from '@/types/auth'
import useCreateDetail, {
  UseCreateDetailOptions,
} from '../core-hooks/useCreateDetail'
import { createDetail } from '../request-wrappers'

/**
 * MARK: Action Hook: Exchange Token
 * This hook provides a mutation to exchange an authentication token.
 */
export function useExchangeToken(
  options: UseCreateDetailOptions<
    ExchangeTokenRequest,
    ExchangeTokenResponse
  > = {},
) {
  const mutation = useCreateDetail<ExchangeTokenRequest, ExchangeTokenResponse>(
    {
      serviceFn: (serviceFnOptions) =>
        createDetail<ExchangeTokenRequest, ExchangeTokenResponse>({
          url: '/v2/auth/exchange_token',
          ...serviceFnOptions,
        }),
      ...options,
    },
  )

  return {
    exchangeToken: mutation.mutate,
    exchangeTokenAsync: mutation.mutateAsync,
    ...mutation,
  }
}
